import React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { Paper as PaperOrigin } from 'components/UI'
// themes
import { colors } from 'themes'
import { ellipsis } from 'polished'

const Wrapper = styled(({ canComplete, isGroupedByPlan, children, ...props }) => (
  <PaperOrigin {...props}>{children}</PaperOrigin>
))`
    margin: 1px 1px 16px 20px;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
}
    && {
        cursor: pointer;
        margin-bottom: 16px;
        margin-left: ${({ isGroupedByPlan }) => (!isGroupedByPlan ? 'unset' : '41px')};
        width: ${({ isGroupedByPlan, canComplete }) =>
          isGroupedByPlan
            ? `calc(75% ${canComplete ? '+ 85px' : '- 40px'})`
            : `calc(75% + ${canComplete ? '125px' : '0px'})`};

        ${({ canComplete }) => canComplete && 'border-radius: 0 35px 35px 0;'};

        @media (max-width: 768px) {
            border-radius: 0;
            height: 200px;
            margin: 0;
            min-width: 300px;
            padding: 8px;

            ${({ isGroupedByPlan }) =>
              !isGroupedByPlan &&
              css`
                width: 100%;
                min-width: unset;
              `}
        }
`

const InnerWrapper = styled(Grid)`
  && {
    height: 58px;

    & > div {
      margin-left: 8px;
    }

    @media (max-width: 768px) {
      height: 100%;

      & > div:nth-child(1) {
        width: 100%;
      }

      & > div:nth-child(2) {
        width: 100% !important;
      }
    }
  }
`

const Details = styled(Grid)`
  && {
    & > div {
      font-size: 12px;
      margin-right: 4px;
    }
  }
`

const Description = styled('div')`
  color: ${colors.gray320};
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const TaskPath = styled((props) => <Grid {...props} />)`
  color: ${colors.gray300};
  flex: 1;
  ${ellipsis('100%')};
`
export { Wrapper, InnerWrapper, Details, Description, TaskPath }
